import React from 'react';
import { COLOR } from '../App/constants';
import { platformHandler } from '../platforms/PlatformHandler'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { languageManager } from '../utils/languageManager'

import {FwScene} from './FwScene'
import FwModalLoader from '../components/FwModalLoader';

import is_js from 'is_js';

import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';



const REGISTER_URL = 'https://www.flipwit.com/registro/';
               
const styles = theme => ({
	//['@media (max-height: 450px)']: {
  /*layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },*/
  paper: {
  	display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '50%',
    maxHeight: 320,
    maxWidth: 480,
    minHeight: 225,
    width: '80%',
    margin: theme.spacing.unit,
    minWidth: 230,    
    borderRadius: '10px',    
    //padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  paperAccount: {
  	display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '20%',
    maxHeight: 320,
    maxWidth: 480,
    width: '80%',
    margin: theme.spacing.unit,
    minWidth: 230,
    minHeight: 100,
    borderRadius: '10px',        
    //padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '80%',	
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },
  paperTitle: {
    color: 'black',
    //height: '17%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 2px -2px ' + COLOR.FLIPWIT_COLOR_2,
    width: '100%',
    marginBottom: "auto",
  },
  labelNoAccount: {
    display: 'flex',
    alignItems: 'inherit',
    fontSize: '1.3em',
    color: 'black',
    marginTop: "16px",
    textAlign: 'center',
  },
  labelTitlePaper: {
    display: 'flex',
    alignItems: 'inherit',
    fontSize: '1.3em',
    margin: "8px",
    color: COLOR.FLIPWIT_COLOR_2,
  },
  buttonRegister: {
    display: 'flex',
    alignItems: 'inherit',
    fontSize: '1.1em',
    color: '#50738F',
    textTransform: 'none',
    textDecoration: 'underline',
  },
  middleBoxPaper: {
    //height: '55%',
    display: 'flex',
    //Se hace un translate en vez de usar margin ya que
    //el margin de arriba y abajo se calculan con el width
    //y no con el height y eso no sirve
    transform: 'none',
    //margin: '0% 5%',
    fontSize: '0.9em',
    alignItems: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    width: '100%',    
  },
  bottomBoxPaper: {
    //height: '28%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    marginTop: "auto",
  },
  button: {
    backgroundColor: COLOR.FLIPWIT_COLOR_1,
    color: 'white',
    width: '80%',
    minWidth: 100,
    marginBottom: "16px",
    '&:hover': {
      backgroundColor: COLOR.FLIPWIT_COLOR_2,
     }   
  },
  flipwitContent: {
    height:'calc(100% - 65px)',
    display: 'flex',    
    //justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'nowrap',    
    flexDirection: 'column',     
    width: '100%',
  },  
  formControl: {
  	'@media (max-height: 700px)': {  		
  		marginTop: 0,
  	}
  }
});

class Login extends FwScene {

	state = {
	    form: {
	      email: '',
	      password: ''
	    },	    
	    showLoader: false,
	    ctrlToFocus: null,
	  }

	componentDidMount(){
		console.log('Monta Login')
		platformHandler.checkTitleBarScene("Login");
		//document.body.scrollTop = 0;
	}

	handleKeyPress = (evt) => {
	    if (evt.key === 'Enter') {
	      this.onLoginPress(null);
	    }
	}

	onLoginPress = (evt) => {		

		console.log(this)

    if(this.state.form.password === "") {
      ReactDOM.findDOMNode(this.inputPass).focus();
      return;
    } 

		if (is_js.email(this.state.form.email.trim()) === false) {
          this.openModal({title:languageManager.getLangWord("OOPS"),message: languageManager.getLangWord("LOGIN_ERROR_EMAIL")})			
	      	return false;
	    }
	    else {
	      this.setState({showLoader: true});

	      platformHandler.fetchSignInMethodsForEmail(this.state.form.email.trim()).then(methods => {
	        console.log(methods);
	        if(methods.indexOf("password")>=0) {

	          platformHandler.signInWithEmailAndPassword(this.state.form)
	            .then(() => {
	              this.setState({errormsg: false});
	            }).catch((err) => {
	              let errorMsg = '';
	              console.error(err.code);
	              switch(err.code) {
	                case 'auth/user-not-found':
	                  errorMsg = languageManager.getLangWord("LOGIN_ERROR_NOT_EXISTS")
	                  break;
	                case 'auth/wrong-password':
	                  errorMsg = languageManager.getLangWord("LOGIN_ERROR_PASSWORD")
	                  break;
	                default:
	                  errorMsg = err.message
	                  break;
	              }
	            	this.setState({showLoader: false});
					      this.openModal({title:languageManager.getLangWord("OOPS"),message: errorMsg})
	            });

	        } else {
            console.log('Realmente es error LOGIN_ERROR_NOT_BY_PASSWORD')
	          this.openModal({title:languageManager.getLangWord("OOPS"),message: languageManager.getLangWord("LOGIN_ERROR_NOT_EXISTS")})
	          this.setState({showLoader: false});
	        }
	      }).catch(errMethods => {
	      	this.openModal({title:languageManager.getLangWord("OOPS"),message: languageManager.getLangWord("LOGIN_ERROR_NOT_EXISTS")})	      	
	        this.setState({showLoader: false});
	      });
	    }
	}

	onCreateAccountPress = (evt) => {
	    this.openURL('https://www.flipwit.com/registro/');
	}

	openURL = (url) =>{
	    if ( platformHandler.isElectron ){
	      var os = window.require('os');
	      var child_process = window.require("child_process")
	      
	      if( os.platform() === "darwin"){
	        child_process.execSync('open ' + url)
	      }
	      else{
	        child_process.execSync('start ' + url)
	      }     
	    }
	    else{
	    	window.location = url	      
	    }
	}

  openRegister = () => {
    platformHandler.openExternalURL(REGISTER_URL);    
  }

	setFormValue = (field, val) => {
	    this.setState({ form: { ...this.state.form, [field]: val }})
	}

	render() {
		const { classes } = this.props;

    var href = REGISTER_URL;
    var target = "_blank";

    //Para electron no se utiliza el link con href ya que esto abriria otra ventana de electron
    //y ahi no funciona el sitio, entonces debe es invocar la funcion openRegister
    if(platformHandler.isElectron) {
      href = undefined;
      target = undefined;
    }

		return (
			<div className={classes.flipwitContent}>
          {this.state.showLoader && <FwModalLoader />}
			    <Paper className={classes.paper}>
				  <div className={classes.paperTitle}>
	              	<div className={classes.labelTitlePaper}>{languageManager.getLangWord("TITLE_LOGIN")}</div>
	              </div>
	              <div className={classes.middleBoxPaper}>
              		<form className={classes.form}>
			            <FormControl margin="normal" required fullWidth className={classes.formControl}>
			            <InputLabel htmlFor="email">{languageManager.getLangWord("LABEL_USERNAME")}</InputLabel>
			              <Input 
			              	id="email" 
			              	name="email" 
			              	autoComplete="email" 
			              	value={this.state.form.email}
			              	onChange={e => this.setFormValue('email', e.target.value)}
			              	disabled={this.state.showLoader}
			              	onKeyPress={this.handleKeyPress}
			              	autoFocus />
			            </FormControl>
			            <FormControl margin="normal" required fullWidth className={classes.formControl}>
			              <InputLabel htmlFor="password">{languageManager.getLangWord("LABEL_PASSWORD")}</InputLabel>
			              <Input
			              	value={this.state.form.password}
			              	onChange={e => this.setFormValue('password', e.target.value)}
			              	disabled={this.state.showLoader}
			              	name="password"
			                type="password"
			                id="password"
			                autoComplete="current-password"
			                onKeyPress={this.handleKeyPress}
                      inputRef={ref => { this.inputPass = ref; }}
			              />
			            </FormControl>			            
			        </form>
            	  </div>		      
            	  <div className={classes.bottomBoxPaper}>
		              <Button variant="contained" className={classes.button} onClick={this.onLoginPress}>
		                {languageManager.getLangWord("LOGIN_PLAIN_BUTTON")}
		              </Button>
		          </div>
		        </Paper>
		        <Paper className={classes.paperAccount}>
		        	<div className={classes.labelNoAccount}>{languageManager.getLangWord("LOGIN_NOT_ACCOUNT_YET")}</div>
		        	<Button className={classes.buttonRegister} onClick={this.openRegister} href={href} target={target}>{languageManager.getLangWord("LOGIN_CREATE_YOUR_ACCOUNT")}</Button>
		        </Paper>
		    </div>
		);    
	}
}

Login.contextTypes = {
  store: PropTypes.object
};

Login.propTypes = {
  classes: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object,
};

/*const styles = StyleSheet.create({
	container: {
		display: '-webkit-box',
		//height: 'calc(100vh - ' + platformHandler.titleBarHeight*2 + 'px)',
		width: '100%',
		paddingTop: 5,
		backgroundColor: COLOR.BACKGROUND
	}
});*/

const mapStateToProps = state => {  	
  return {
  	language: state.containers.appReducer.language,    
  }
};

export default connect(mapStateToProps)(withStyles(styles,{ withTheme: true })(Login));




// WEBPACK FOOTER //
// ./src/containers/scenes/Login.js